import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { SurveyState } from './types';

const state: SurveyState = {
  previewSurveyId: null,
  publishedSurveyId: null,
  surveys: {},
  isSurveyMinimized: false,
  showLoading: false
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
